import { useLayoutEffect } from 'react'
import { FileOperationStatus } from '@/graphql/schema'
import { useFileOperationQuery } from '@/graphql/queries/fileOperationQuery.gql.generated'

const POLL_MS = 2000
const TERMINAL = new Set<FileOperationStatus>([
  FileOperationStatus.Succeeded,
  FileOperationStatus.Failed,
  FileOperationStatus.Cancelled,
])

/** Polls an operation until it reaches a terminal status. */
export function useFileOperationPolling(id: string) {
  const query = useFileOperationQuery({
    variables: { id },
    fetchPolicy: 'cache-and-network',
    pollInterval: POLL_MS,
    context: { globalLoader: false },
  })
  const { stopPolling } = query
  const status = query.data?.fileOperation.status

  useLayoutEffect(() => {
    if (status !== undefined && TERMINAL.has(status)) stopPolling()
  }, [status, stopPolling])

  return query.data?.fileOperation
}
